const charges_cargo = [
  { period: 0, start: 0, end: 5, fee: 0, multiply: 0 },
  { period: 1, start: 6, end: 10, fee: 3600, multiply: 1 },
  { period: 2, start: 11, end: 15, fee: 7200, multiply: 2 },
  { period: 3, start: 16, end: 21, fee: 21600, multiply: 3 },
  { period: 4, start: 22, end: 10000000, fee: 21600, multiply: 4 }
];

const charges_transit_cargo = [
  // starts from when the vessel arrives for transit
  { period: 0, start: 0, end: 20, fee: 0, multiply: 0 },
  { period: 1, start: 21, end: 28, fee: 1231.20, multiply: 1 }, // 1,231.20 //every seven working days 36*34.20 - 40ft 72*
  { period: 2, start: 27, end: 32, fee: 1166.40, multiply: 2 }, // 1,166.40 // 36*32.40  - 72*
  { period: 3, start: 33, end: 38, fee: 3600, multiply: 3 }, // 3,600 //36* 100 - 72 *
  { period: 4, start: 39, end: 1000000, fee: 5997.60, multiply: 4 } // beyond 3rd period 5,997.60
];

const charges_roro = [
  { period: 0, start: 0, end: 5, fee: 0 },
  { period: 1, start: 6, end: 9, fee: 375 },
  { period: 2, start: 10, end: 13, fee: 875 }, //500+375
  { period: 3, start: 14, end: 17, fee: 1375 }, // eevry three days is 500 and those not have a stop date, every three days is an added GMD500
  { period: 4, start: 17, end: 20, fee: 1875 }
];

const charges_roro_10k = [
  { period: 0, start: 0, end: 5, fee: 0 },
  { period: 1, start: 6, end: 9, fee: 562.50 },
  { period: 2, start: 10, end: 13, fee: 1312.50 }, //750+562.50
  { period: 3, start: 14, end: 17, fee: 2062.50 }, // eevry three days is 750 and those not have a stop date, every three days is an added GMD500
  { period: 4, start: 17, end: 20, fee: 2812.50 }
];

const charges_roro_10k_plus = [
  { period: 0, start: 0, end: 5, fee: 0 },
  { period: 1, start: 6, end: 9, fee: 750 },
  { period: 2, start: 10, end: 13, fee: 1750 }, //1000+750
  { period: 3, start: 14, end: 17, fee: 2750 }, // eevry three days is 1000 and those not have a stop date, every three days is an added GMD500
  { period: 4, start: 17, end: 20, fee: 3750 }
];

export {
  charges_cargo,
  charges_transit_cargo,
  charges_roro,
  charges_roro_10k,
  charges_roro_10k_plus
};
